import React from 'react';

import { LocationDTO } from '@peartherapeutics/weaver-api-client';
import styles from './styles.scss';

export interface IRowProps {
  location: LocationDTO;
  isLocationWrite: boolean;
  onClickEditLocation: () => void;
}

const DisplayLocation = ({
  isLocationWrite,
  location,
  onClickEditLocation,
}: IRowProps) => {
  return (
    <tr
      className={`${styles['align-middle']} ${styles['table-row']}`}
      data-testid="view-location"
    >
      <td style={{ width: isLocationWrite ? 225 : 290 }}>
        <span>{location.name}</span>
      </td>
      <td style={{ width: isLocationWrite ? 230 : 290 }}>
        <span>{location.addressLine1}</span>
        <div>{location.addressLine2}</div>
      </td>
      <td style={{ width: isLocationWrite ? 120 : 170 }}>
        <span>{location.city}</span>
      </td>
      <td style={{ width: isLocationWrite ? 100 : 120 }}>
        <span>{location.district}</span>
      </td>
      <td style={{ width: isLocationWrite ? 100 : 110 }}>
        <span>{location.postalCode}</span>
      </td>
      <td style={{ width: 115 }}>
        <span>{location.externalRef}</span>
      </td>
      {isLocationWrite && (
        <td style={{ width: 200 }} styleName="row-actions">
          <button styleName="edit" type="button" onClick={onClickEditLocation}>
            Edit
          </button>
        </td>
      )}
    </tr>
  );
};

export default DisplayLocation;
